import { Button, Field } from "@odus/ui";

import { ApiStatus } from "../components/api-status";

/** Tela de entrada. Por enquanto só a casca: o login com 2FA chega na S3. */
export function EntrarPage() {
  return (
    <main className="mx-auto flex min-h-dvh max-w-md flex-col justify-center gap-6 px-4 py-10">
      <header className="text-center">
        <p className="font-[family-name:var(--font-eyebrow)] text-eyebrow tracking-[0.2em] text-gold-text uppercase">
          Odus
        </p>
        <h1 className="mt-2 font-display text-h2-sm text-ink">Entrar</h1>
      </header>

      <form
        className="flex flex-col gap-4 rounded-[var(--radius-card)] bg-paper p-6 shadow-[var(--shadow-elevated)]"
        onSubmit={(e) => e.preventDefault()}
        aria-describedby="login-aviso"
      >
        <Field label="E-mail" type="email" autoComplete="username" disabled />
        <Field label="Senha" type="password" autoComplete="current-password" disabled />
        <Button track="adm.auth.login" type="submit" disabled>
          Entrar
        </Button>
        <p id="login-aviso" className="text-center text-[13px] text-muted">
          O login com 2FA chega na próxima etapa.
        </p>
      </form>

      <ApiStatus />
    </main>
  );
}
